module.exports = __webpack_public_path__ + "img/password-logn.ded10224.svg";